export interface StockTypeCoverage {
	stocked: {
		isSelected: boolean;
	};
	demand: {
		isSelected: boolean;
	};
	remote: {
		isSelected: boolean;
	};
	nonstock: {
		isVisible: boolean;
		isSelected: boolean;
	};
	showCoverageFilterNotification: boolean;
}

export function getStockTypes(coverage: StockTypeCoverage): string[] {
	const types = [];
	if (coverage.stocked.isSelected) {
		types.push('S');
	}
	if (coverage.demand.isSelected) {
		types.push('D');
	}
	if (coverage.remote.isSelected) {
		types.push('R');
	}
	if (coverage.nonstock.isSelected) {
		types.push('N');
	}
	return types;
}
